import { api } from "./api";

// CSV / print export helpers
export async function downloadXlsx(reportType, params) {
  const res = await api.get(`/reports/${reportType}/export.xlsx`, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `billone-${reportType}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportCSV(filename, rows, columns) {
  if (!rows || !rows.length) return;
  const header = columns.map((c) => `"${c.label}"`).join(",");
  const body = rows
    .map((r) => columns.map((c) => `"${String(r[c.key] ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const csv = header + "\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function printTable(title, rows, columns) {
  const header = columns.map((c) => `<th>${c.label}</th>`).join("");
  const body = rows
    .map((r) => `<tr>${columns.map((c) => `<td>${r[c.key] ?? ""}</td>`).join("")}</tr>`)
    .join("");
  const w = window.open("", "_blank", "width=900,height=650");
  w.document.write(`<!doctype html><html><head><title>${title}</title>
  <style>
    body{font-family:'Segoe UI',Arial,sans-serif;padding:24px;color:#0F172A;}
    h1{color:#1A2A5E;font-size:20px;margin:0 0 4px;}
    .sub{color:#64748B;font-size:12px;margin-bottom:16px;}
    table{width:100%;border-collapse:collapse;font-size:12px;}
    th{background:#1A2A5E;color:#fff;text-align:left;padding:8px;}
    td{padding:7px 8px;border-bottom:1px solid #E2E8F0;}
    tr:nth-child(even){background:#F8FAFC;}
  </style></head><body>
  <h1>BillOne — ${title}</h1>
  <div class="sub">Generated ${new Date().toLocaleString("en-IN")}</div>
  <table><thead><tr>${header}</tr></thead><tbody>${body}</tbody></table>
  <script>window.onload=function(){window.print();setTimeout(()=>window.close(),400);}</script>
  </body></html>`);
  w.document.close();
}
